import SectionHeading from 'components/shared/SectionHeading'
import React, { useState } from 'react'
import { Select } from 'components/ui'

export const timezones = [
    {
        value: 'US/Eastern',
        label: 'Eastern Standard Time (EST)',
        shortLabel: 'EST',
    },
    {
        value: 'US/Pacific',
        label: 'Pacific Standard Time (PST)',
        shortLabel: 'PST',
    },
    {
        value: 'US/Central',
        label: 'Central Time (CT)',
        shortLabel: 'CT',
    },
    {
        value: 'US/Mountain',
        label: 'Mountain Time (MST)',
        shortLabel: 'MST',
    },
    {
        value: 'HST',
        label: 'Hawaii Time (HST)',
        shortLabel: 'HST',
    },
]

const generateTimeSlots = (interval, startHour = 0, endHour = 24) => {
    const times = []
    for (let hour = startHour; hour < endHour; hour++) {
        for (let minutes = 0; minutes < 60; minutes += interval) {
            const time12Hour = new Date(
                0,
                0,
                0,
                hour,
                minutes,
                0
            ).toLocaleTimeString([], {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            })
            const time24Hour = `${String(hour).padStart(2, '0')}:${String(
                minutes
            ).padStart(2, '0')}:00`
            times.push({ value: time24Hour, label: time12Hour })
        }
    }
    return times
}

const MediationTime = ({ values, handleChange, handleUpdate }) => {
    const [morningSlots] = useState(generateTimeSlots(15, 0, 12))
    const [afternoonSlots] = useState(generateTimeSlots(15, 12, 24))
    const [fulldaySlot] = useState(generateTimeSlots(15, 0, 24))

    const handleTimeChange = (key, newTime) => {
        handleChange(key, newTime)
    }

    const mediationTimeValues = values.mediationTime
    const mediationGscTimeValues = values.mediatorSettings

    return (
        <div className="col-span-2 p-4 rounded-xl" data-onboarding="step-2-mediation-time">
            <SectionHeading title="Mediation Time" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-7 bg-white p-2 lg:p-8 rounded-md shadow">
                <div className="grid grid-cols-1">
                    <h2 className="font-semibold text-sm  pb-3 col-span-1 flex items-center">
                        {'Timezone'}
                    </h2>
                    <Select
                        onChange={(e) =>
                            handleChange('mediationTime.timezone', e.value)
                        }
                        className="w-full col-span-2"
                        options={timezones}
                        value={timezones.find(
                            (tz) => tz.value === mediationTimeValues.timezone
                        )}
                        onBlur={() =>
                            handleUpdate({
                                timezone: mediationTimeValues.timezone,
                            })
                        }
                    />
                </div>
                <div className="grid grid-cols-1">
                    <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                        {'Morning Slot'}
                    </h2>
                    <Select
                        value={
                            morningSlots.filter(
                                (item) =>
                                    item.value ===
                                    mediationTimeValues.morning_time
                            )[0]
                        }
                        className="w-full col-span-2"
                        options={morningSlots}
                        onChange={(e) => {
                            handleTimeChange(
                                'mediationTime.morning_time',
                                e.value
                            )
                        }}
                        onBlur={() =>
                            handleUpdate({
                                morning_time: mediationTimeValues.morning_time,
                            })
                        }
                    />
                </div>
                <div className="grid grid-cols-1">
                    <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                        {'Afternoon Slot'}
                    </h2>

                    <Select
                        value={
                            afternoonSlots.filter(
                                (item) =>
                                    item.value ===
                                    mediationTimeValues.afternoon_time
                            )[0]
                        }
                        className="w-full col-span-2 "
                        options={afternoonSlots}
                        onChange={(e) => {
                            handleTimeChange(
                                'mediationTime.afternoon_time',
                                e.value
                            )
                        }}
                        onBlur={() =>
                            handleUpdate({
                                afternoon_time:
                                    mediationTimeValues.afternoon_time,
                            })
                        }
                    />
                </div>

                <div className="grid grid-cols-1">
                    <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                        {'Full Day Slot'}
                    </h2>

                    <Select
                        value={
                            fulldaySlot.filter(
                                (item) =>
                                    item.value ===
                                    mediationTimeValues.fullday_time
                            )[0]
                        }
                        className="w-full col-span-2 "
                        options={fulldaySlot}
                        onChange={(e) => {
                            handleTimeChange(
                                'mediationTime.fullday_time',
                                e.value
                            )
                        }}
                        onBlur={() =>
                            handleUpdate({
                                fullday_time: mediationTimeValues.fullday_time,
                            })
                        }
                    />
                </div>
            </div>

            {mediationGscTimeValues?.is_gsc_cases_allowed === true && (
                <>
                    <SectionHeading title="GSC Mediation Time" />
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-7 bg-white p-2 lg:p-8 rounded-md shadow">
                        <div className="grid grid-cols-1">
                            <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                                {'GSC Morning Slot'}
                            </h2>
                            <Select
                                value={
                                    morningSlots.filter(
                                        (item) =>
                                            item.value ===
                                            mediationGscTimeValues.gsc_morning_time
                                    )[0]
                                }
                                className="w-full col-span-2"
                                options={morningSlots}
                                onChange={(e) => {
                                    handleTimeChange(
                                        'mediatorSettings.gsc_morning_time',
                                        e.value
                                    )
                                }}
                                onBlur={() =>
                                    handleUpdate(
                                        {
                                            gsc_morning_time:
                                                mediationGscTimeValues.gsc_morning_time,
                                        },
                                        true
                                    )
                                }
                            />
                        </div>
                        <div className="grid grid-cols-1">
                            <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                                {'GSC Afternoon Slot'}
                            </h2>

                            <Select
                                value={
                                    afternoonSlots.filter(
                                        (item) =>
                                            item.value ===
                                            mediationGscTimeValues.gsc_afternoon_time
                                    )[0]
                                }
                                className="w-full col-span-2 "
                                options={afternoonSlots}
                                onChange={(e) => {
                                    handleTimeChange(
                                        'mediatorSettings.gsc_afternoon_time',
                                        e.value
                                    )
                                }}
                                onBlur={() =>
                                    handleUpdate(
                                        {
                                            gsc_afternoon_time:
                                                mediationGscTimeValues.gsc_afternoon_time,
                                        },
                                        true
                                    )
                                }
                            />
                        </div>

                        <div className="grid grid-cols-1">
                            <h2 className="font-semibold text-sm pb-3 col-span-1 flex items-center">
                                {'GSC Full Day Slot'}
                            </h2>

                            <Select
                                value={
                                    fulldaySlot.filter(
                                        (item) =>
                                            item.value ===
                                            mediationGscTimeValues.gsc_fullday_time
                                    )[0]
                                }
                                className="w-full col-span-2 "
                                options={fulldaySlot}
                                onChange={(e) => {
                                    handleTimeChange(
                                        'mediatorSettings.gsc_fullday_time',
                                        e.value
                                    )
                                }}
                                onBlur={() =>
                                    handleUpdate(
                                        {
                                            gsc_fullday_time:
                                                mediationGscTimeValues.gsc_fullday_time,
                                        },
                                        true
                                    )
                                }
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default MediationTime
